import React from 'react'
import PerfectScrollbar from 'react-perfect-scrollbar'
import PropTypes from 'prop-types'
import { Box, Paper, Typography } from '@material-ui/core'

import { JoditEditor } from 'components'

import helpers from 'helpers'

import theme from 'theme'
import useStyles from './styles'

const MessageBox = ({ consentForm }) => {
  const classes = useStyles()

  return (
    <Paper variant="outlined">
      <Box p={2} bgcolor={theme.palette.background.default}>
        <Typography variant="h6">Texto do Consentimento</Typography>
        <Typography color="secondary" variant="caption">
          {helpers.consent.legalFrameworkLabel(consentForm?.legalFrameworkId)}
        </Typography>
      </Box>
      <Box className={classes.messageContainer}>
        <PerfectScrollbar>
          <Box pr={2}>
            <JoditEditor.Preview allowIframe content={consentForm?.content} />
          </Box>
        </PerfectScrollbar>
      </Box>
    </Paper>
  )
}

MessageBox.propTypes = {
  consentForm: PropTypes.object,
}

export default MessageBox
